import type { CountriesRecord } from '@/services/api/mainstream';

export const isJurisdictionPermitted = (countryCode: keyof CountriesRecord, countries: CountriesRecord) => {
  const jurisdiction = countries[countryCode];
  if (!jurisdiction) throw new Error(`Jurisdiction (Country: ${countryCode}) not found`);

  return jurisdiction.amlRisk !== 'prohibited';
};
